












































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface, TextField } from '@/components/atoms';
import { Radio } from '@/components/molecules';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import PinIcon from '@/components/icons/Pin.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';

@Component({
  components: {
    Typography,
    Surface,
    Radio,
    Checkbox,
    TextField,
    PinIcon,
    FormHeader
  }
})
export default class OfferFreeCoinsLocationSettings extends Vue {
  @Prop({ default: 'nationwide' }) readonly value!: string;

  get businessCountry() {
    return this.$store.getters['internationalization/getCountrySettings'].name;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get descriptionNationWide() {
    return 'Welcome Coins are promoted in every city, and anyone can claim them.';
  }

  get descriptionLocal() {
    return 'Welcome Coins are promoted only in your local area through the Twism app, but anyone can still claim them.';
  }
}
